var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4987 68C59.382 67.958 62.6807 65.5169 64.5962 63.6795C69.2911 59.1884 72 52.4609 72 45.5445V45.408C72 40.1662 70.5594 35.1344 67.2372 31.6145C64.6484 28.861 60.572 27.2494 58.038 27.0341V27.0472C57.3855 27.0341 57.0593 27.021 56.4043 27C56.1015 27.0052 55.9658 27 55.6631 27.0052C55.6161 27.0052 55.5535 27.021 55.4987 27.021C55.4413 27.021 55.3813 27.0052 55.3265 27.0052C55.0289 27 54.888 27.0052 54.5931 27C53.9381 27.021 53.6119 27.0341 52.9516 27.0472V27.0341C50.4228 27.2494 46.3516 28.861 43.7601 31.6145C40.438 35.1344 39 40.1662 39 45.408V45.5445C39 52.4609 41.7037 59.1884 46.3986 63.6795C48.3141 65.5169 51.6128 67.958 55.4987 68",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9913 72.3654L64.6943 70.0207C62.3422 71.7766 59.1948 73.3699 55.4724 73.4061C51.8052 73.3699 48.6683 71.7715 46.3083 70L42.9981 72.3654C42.9981 72.3654 27.5812 74.1678 20 85.9974C28.6154 95.787 41.3312 102 55.4961 102C69.6661 102 82.374 95.787 91 85.9974C83.4004 74.1678 67.9913 72.3654 67.9913 72.3654",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5001 110.5C85.8758 110.5 110.5 85.8756 110.5 55.4999C110.5 25.1216 85.8758 0.499908 55.5001 0.499908C25.1244 0.499908 0.500061 25.1216 0.500061 55.4999C0.500061 85.8756 25.1243 110.5 55.5001 110.5Z",
    stroke: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.44cda1ce2a567f7065eefacbd692bb94.svg";
export { ForwardRef as ReactComponent };